export const ROUTES = {
  base: "/",
  login: "/login",
  signUp: "/sign-up/:invitationCode",
  resetPassword: "/reset-password-screen",
  forgotPassword: "/forgot-password",
  home: "/home",
  newIntake: "/new-intake",
  users: "/users",
  serverError: "/server-error",
  twoFactorAuthSetup: "/two-factor-setup",
  twoFactorAuthChallenge: "/two-factor-challenge",
  activePatient: "/active",
  disqualifiedPatient: "/disqualified",
  transferredPatient: "/transferred",
  endScreenRegistered: "/end-screen/registered",
  endScreenTransferred: "/end-screen/transferred",
  endScreenDisqualified: "/end-screen/disqualified",
  casesList: "/cases",
  notFound: "*",
} as const;

export const MODAL_ROUTES = {
  exampleModal: "/example-modal",
  userForm: "/user-form",
} as const;
